import API from 'js/lib/api';

const itemFeedbackCommentCountsAPI = API('/api/itemFeedbackCommentCounts.v1', {
  type: 'rest',
});

export default itemFeedbackCommentCountsAPI;
